<template>
  <v-list-group :ripple="false" no-action sub-group :key="item.title" :value="isActive" class="app-list-group">
    <template #prependIcon>
      <div class="icon-container">
        <FIcon :name="item.icon" class="img-icon" />
      </div>
    </template>
    <template #appendIcon>
      <span class="arrow-menu"></span>
    </template>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t(`${item.title}`) }}
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <div class="nav-list-group">
      <v-list-item-title class="sub-list-title">
        <v-list-item>
          <v-list-item-title v-text="$t(`${item.title}`)"> </v-list-item-title>
        </v-list-item>
      </v-list-item-title>
      <v-list-item
        v-for="(iLink, i) in item.children"
        :key="`nav-g-link-${i}`"
        link
        :to="iLink.href"
        :class="{ 'v-list-item--active': isSubLinkActive(iLink) }"
      >
        <v-list-item-title v-text="$t(`${iLink.title}`)"> </v-list-item-title>
      </v-list-item>
    </div>
  </v-list-group>
</template>

<script>
const LinkGroup = {
  name: "LinkGroup",

  props: {
    item: {
      required: true,
    },
  },

  computed: {
    isActive() {
      return this.item?.name === this.$route?.meta?.parent;
    },
  },

  methods: {
    isSubLinkActive(link) {
      const currentPage = link.href.split("/")[2];
      return this.$route.fullPath.includes(currentPage);
    },
  },
};
export default LinkGroup;
</script>
